import fetchApi from "../fetchApi";
export const CreateShippingAddress = async (
    status,
    office,
    name,
    firstName,
    lastName,
    company_id,
    address1,
    address2,
    postalCode,
    state,
    city,
    country,
    shipping_method ) => {

    const fields = {
        "is_active": status,
        "name": name,
        "first_name": firstName,
        "last_name": lastName,
        "company_id": company_id,
        "address": address1,
        "address_additional": address2,
        "postal_code": postalCode,
        "state": state,
        "city": city,
        "country": country,
        "shipping_method": shipping_method
    };

    if(office.length !== 0 ){
        fields.office_id = office;
    }

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(fields),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/shipping-addresses`, options);
};